export default {
    state: {
        pageList: [],
        settings: [],
    },

    getters: {
    },

    mutations: {
        storeSetPageList(state, pageList) {
            state.pageList = pageList;
        },
        storeSetPageSettings(state, settings) {
            state.settings = settings;
        },
    },

    actions: {
    },
};
